<template>
  <nav class="navbar navbar-expand-lg navbar-light py-2">
    <span class="navbar-brand">
      <img
        :alt="headerLogoAlt"
        :height="headerLogoHeight"
        :src="headerLogoSrc"
        :width="headerLogoWidth"
      >
      <button
        v-if="isSignInButtonEnabled"
        size="sm"
        class="btn btn-outline-primary float-right"
        type="button"
        @click="signInButtonClicked"
      >
        Sign in
      </button>
    </span>
  </nav>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        headerLogoAlt: 'leadChannel/headerLogoAlt',
        headerLogoHeight: 'leadChannel/headerLogoHeight',
        headerLogoSrc: 'leadChannel/headerLogoSrc',
        headerLogoWidth: 'leadChannel/headerLogoWidth',
        isSignInButtonEnabled: 'feature/isSignInButtonEnabled'
      })
    },
    methods: {
      signInButtonClicked () {
        window.location.assign(process.env.CONSUMER_PORTAL_URL);
      }
    }
  };

</script>

<style>
.navbar-brand {
  width: 100%;
}
</style>
